import { useDraggable } from '@dnd-kit/core'
import { Box } from '@mui/material'
import { CarrierVisitStatus } from '@planning/app/api'
import { FC } from 'react'
import {
  RailcarPlanningDraggableEnum,
  RailcarPlanningViewStore,
} from '../../Stores/RailcarPlanningViewStore'
import {
  RailcarPlanningRailcar,
  RailcarPlanningRailcarProps,
} from '../Molecules/RailcarPlanningRailcar'

type Props = {
  railcarPlanningViewStore: RailcarPlanningViewStore
  railcar: RailcarPlanningRailcarProps
  filter?: string | null
  sequence?: number
}

export const RailcarPlanningDraggableRailcar: FC<Props> = props => {
  const { railcar, railcarPlanningViewStore } = props
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: `${RailcarPlanningDraggableEnum.RAILCAR}:${railcar.id}`,
    disabled: railcarPlanningViewStore.railVisitItem.data.status === CarrierVisitStatus.Closed,
    data: {
      type: RailcarPlanningDraggableEnum.RAILCAR,
      ...railcar,
    },
  })

  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      sx={{ cursor: railcar.isGap ? 'not-allowed' : 'grab' }}
    >
      <RailcarPlanningRailcar {...props} />
    </Box>
  )
}
